import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _18a0152e = () => interopDefault(import('../sites/oknadverenamiru/pages/user/activate.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/user/activate" */))
const _58aa5769 = () => interopDefault(import('../sites/oknadverenamiru/pages/articleList/index.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/articleList/index" */))
const _49c4e7e9 = () => interopDefault(import('../sites/oknadverenamiru/pages/search/index.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/search/index" */))
const _75499cb6 = () => interopDefault(import('../sites/oknadverenamiru/pages/configurator/index.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/configurator/index" */))
const _b5370a56 = () => interopDefault(import('../sites/oknadverenamiru/pages/contact/index.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/contact/index" */))
const _d32e9ef2 = () => interopDefault(import('../sites/oknadverenamiru/pages/checkout/index.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/checkout/index" */))
const _79332228 = () => interopDefault(import('../sites/oknadverenamiru/pages/files/index.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/files/index" */))
const _694b034b = () => interopDefault(import('../sites/oknadverenamiru/pages/faq/index.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/faq/index" */))
const _252d7763 = () => interopDefault(import('../sites/oknadverenamiru/pages/branch/index.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/branch/index" */))
const _aed3d1ca = () => interopDefault(import('../sites/oknadverenamiru/pages/login.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/login" */))
const _507be7e1 = () => interopDefault(import('../sites/oknadverenamiru/pages/register.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/register" */))
const _a6a868b4 = () => interopDefault(import('../sites/oknadverenamiru/pages/passwordReset.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/passwordReset" */))
const _cdbe2a2e = () => interopDefault(import('../sites/oknadverenamiru/pages/sitemapconfig.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/sitemapconfig" */))
const _422317f8 = () => interopDefault(import('../sites/oknadverenamiru/pages/index.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/index" */))
const _6b001a45 = () => interopDefault(import('../sites/oknadverenamiru/pages/maintenance.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/maintenance" */))
const _47792068 = () => interopDefault(import('../sites/oknadverenamiru/pages/user/index.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/user/index" */))
const _cee05d3a = () => interopDefault(import('../sites/oknadverenamiru/pages/aboutPurchase/index.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/aboutPurchase/index" */))
const _05237f71 = () => interopDefault(import('../sites/oknadverenamiru/pages/passwordForgotten.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/passwordForgotten" */))
const _a5d018fa = () => interopDefault(import('../sites/oknadverenamiru/pages/configurator/measurements.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/configurator/measurements" */))
const _41346aee = () => interopDefault(import('../sites/oknadverenamiru/pages/checkout/info.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/checkout/info" */))
const _18166a66 = () => interopDefault(import('../sites/oknadverenamiru/pages/checkout/finished.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/checkout/finished" */))
const _57aa5027 = () => interopDefault(import('../sites/oknadverenamiru/pages/checkout/methods.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/checkout/methods" */))
const _059b5521 = () => interopDefault(import('../sites/oknadverenamiru/pages/checkout/importOrder/index.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/checkout/importOrder/index" */))
const _93a0d06c = () => interopDefault(import('../sites/oknadverenamiru/pages/user/shoppingLists/index.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/user/shoppingLists/index" */))
const _7e341fc4 = () => interopDefault(import('../sites/oknadverenamiru/pages/user/orders/index.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/user/orders/index" */))
const _5abfc499 = () => interopDefault(import('../sites/oknadverenamiru/pages/user/settings.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/user/settings" */))
const _0ba200e4 = () => interopDefault(import('../sites/oknadverenamiru/pages/user/dashboard.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/user/dashboard" */))
const _24efec2c = () => interopDefault(import('../sites/oknadverenamiru/pages/user/addressList.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/user/addressList" */))
const _5cb2c711 = () => interopDefault(import('../sites/oknadverenamiru/pages/user/password.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/user/password" */))
const _7616e0ee = () => interopDefault(import('../sites/oknadverenamiru/pages/checkout/payment/callback.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/checkout/payment/callback" */))
const _e115f69c = () => interopDefault(import('../sites/oknadverenamiru/pages/user/shoppingLists/_id.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/user/shoppingLists/_id" */))
const _0ecd6206 = () => interopDefault(import('../sites/oknadverenamiru/pages/user/orders/_id.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/user/orders/_id" */))
const _56f3b621 = () => interopDefault(import('../sites/oknadverenamiru/pages/articleList/_slug.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/articleList/_slug" */))
const _768aeee3 = () => interopDefault(import('../sites/oknadverenamiru/pages/article/_slug.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/article/_slug" */))
const _7392fb6e = () => interopDefault(import('../sites/oknadverenamiru/pages/configurator/_slug.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/configurator/_slug" */))
const _2376d61b = () => interopDefault(import('../sites/oknadverenamiru/pages/branch/_slug.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/branch/_slug" */))
const _3f3f0b9c = () => interopDefault(import('../sites/oknadverenamiru/pages/product/_slug.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/product/_slug" */))
const _2bc7a048 = () => interopDefault(import('../sites/oknadverenamiru/pages/page/_slug.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/page/_slug" */))
const _2a80cbde = () => interopDefault(import('../sites/oknadverenamiru/pages/_.vue' /* webpackChunkName: "sites/oknadverenamiru/pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/aktivovat",
    component: _18a0152e,
    name: "user-activate___cs"
  }, {
    path: "/clanky",
    component: _58aa5769,
    name: "articleList___cs"
  }, {
    path: "/hledat",
    component: _49c4e7e9,
    name: "search___cs"
  }, {
    path: "/konfigurator",
    component: _75499cb6,
    name: "configurator___cs"
  }, {
    path: "/kontakty",
    component: _b5370a56,
    name: "contact___cs"
  }, {
    path: "/kosik",
    component: _d32e9ef2,
    name: "checkout___cs"
  }, {
    path: "/manualy-ke-stazeni",
    component: _79332228,
    name: "files___cs"
  }, {
    path: "/nejcastejsi-dotazy",
    component: _694b034b,
    name: "faq___cs"
  }, {
    path: "/pobocky",
    component: _252d7763,
    name: "branch___cs"
  }, {
    path: "/prihlasit",
    component: _aed3d1ca,
    name: "login___cs"
  }, {
    path: "/registrovat",
    component: _507be7e1,
    name: "register___cs"
  }, {
    path: "/resetovat-heslo",
    component: _a6a868b4,
    name: "passwordReset___cs"
  }, {
    path: "/sitemapconfig",
    component: _cdbe2a2e,
    name: "sitemapconfig___cs"
  }, {
    path: "/sk",
    component: _422317f8,
    name: "index___sk"
  }, {
    path: "/udrzba",
    component: _6b001a45,
    name: "maintenance___cs"
  }, {
    path: "/uzivatel",
    component: _47792068,
    name: "user___cs"
  }, {
    path: "/vse-o-nakupu",
    component: _cee05d3a,
    name: "aboutPurchase___cs"
  }, {
    path: "/zapomenute-heslo",
    component: _05237f71,
    name: "passwordForgotten___cs"
  }, {
    path: "/konfigurator/rozmery",
    component: _a5d018fa,
    name: "configurator-measurements___cs"
  }, {
    path: "/kosik/dodaci-udaje",
    component: _41346aee,
    name: "checkout-info___cs"
  }, {
    path: "/kosik/dokonceni",
    component: _18166a66,
    name: "checkout-finished___cs"
  }, {
    path: "/kosik/doprava-a-platba",
    component: _57aa5027,
    name: "checkout-methods___cs"
  }, {
    path: "/kosik/import-objednavky",
    component: _059b5521,
    name: "checkout-importOrder___cs"
  }, {
    path: "/sk/aktivovat",
    component: _18a0152e,
    name: "user-activate___sk"
  }, {
    path: "/sk/clanky",
    component: _58aa5769,
    name: "articleList___sk"
  }, {
    path: "/sk/hladat",
    component: _49c4e7e9,
    name: "search___sk"
  }, {
    path: "/sk/konfigurator",
    component: _75499cb6,
    name: "configurator___sk"
  }, {
    path: "/sk/kontakty",
    component: _b5370a56,
    name: "contact___sk"
  }, {
    path: "/sk/kosik",
    component: _d32e9ef2,
    name: "checkout___sk"
  }, {
    path: "/sk/manualy-k-stiahnutiu",
    component: _79332228,
    name: "files___sk"
  }, {
    path: "/sk/najcastejsie-otazky",
    component: _694b034b,
    name: "faq___sk"
  }, {
    path: "/sk/pobocky",
    component: _252d7763,
    name: "branch___sk"
  }, {
    path: "/sk/prihlasit",
    component: _aed3d1ca,
    name: "login___sk"
  }, {
    path: "/sk/registrovat",
    component: _507be7e1,
    name: "register___sk"
  }, {
    path: "/sk/resetovat-heslo",
    component: _a6a868b4,
    name: "passwordReset___sk"
  }, {
    path: "/sk/sitemapconfig",
    component: _cdbe2a2e,
    name: "sitemapconfig___sk"
  }, {
    path: "/sk/udrzba",
    component: _6b001a45,
    name: "maintenance___sk"
  }, {
    path: "/sk/uzivatel",
    component: _47792068,
    name: "user___sk"
  }, {
    path: "/sk/vsetko-o-nakupe",
    component: _cee05d3a,
    name: "aboutPurchase___sk"
  }, {
    path: "/sk/zabudnute-heslo",
    component: _05237f71,
    name: "passwordForgotten___sk"
  }, {
    path: "/uzivatel/nakupni-seznamy",
    component: _93a0d06c,
    name: "user-shoppingLists___cs"
  }, {
    path: "/uzivatel/objednavky",
    component: _7e341fc4,
    name: "user-orders___cs"
  }, {
    path: "/uzivatel/osobni-udaje",
    component: _5abfc499,
    name: "user-settings___cs"
  }, {
    path: "/uzivatel/prehled",
    component: _0ba200e4,
    name: "user-dashboard___cs"
  }, {
    path: "/uzivatel/seznam-adres",
    component: _24efec2c,
    name: "user-addressList___cs"
  }, {
    path: "/uzivatel/zmena-hesla",
    component: _5cb2c711,
    name: "user-password___cs"
  }, {
    path: "/checkout/payment/callback",
    component: _7616e0ee,
    name: "checkout-payment-callback___cs"
  }, {
    path: "/sk/konfigurator/rozmery",
    component: _a5d018fa,
    name: "configurator-measurements___sk"
  }, {
    path: "/sk/kosik/dodacie-udaje",
    component: _41346aee,
    name: "checkout-info___sk"
  }, {
    path: "/sk/kosik/dokoncenie",
    component: _18166a66,
    name: "checkout-finished___sk"
  }, {
    path: "/sk/kosik/doprava-a-platba",
    component: _57aa5027,
    name: "checkout-methods___sk"
  }, {
    path: "/sk/kosik/import-objednavky",
    component: _059b5521,
    name: "checkout-importOrder___sk"
  }, {
    path: "/sk/uzivatel/nakupne-zoznamy",
    component: _93a0d06c,
    name: "user-shoppingLists___sk"
  }, {
    path: "/sk/uzivatel/objednavky",
    component: _7e341fc4,
    name: "user-orders___sk"
  }, {
    path: "/sk/uzivatel/osobni-udaje",
    component: _5abfc499,
    name: "user-settings___sk"
  }, {
    path: "/sk/uzivatel/prehled",
    component: _0ba200e4,
    name: "user-dashboard___sk"
  }, {
    path: "/sk/uzivatel/zmena-hesla",
    component: _5cb2c711,
    name: "user-password___sk"
  }, {
    path: "/sk/uzivatel/zoznam-adries",
    component: _24efec2c,
    name: "user-addressList___sk"
  }, {
    path: "/sk/checkout/payment/callback",
    component: _7616e0ee,
    name: "checkout-payment-callback___sk"
  }, {
    path: "/",
    component: _422317f8,
    name: "index___cs"
  }, {
    path: "/sk/uzivatel/nakupne-zoznamy/:id",
    component: _e115f69c,
    name: "user-shoppingLists-id___sk"
  }, {
    path: "/sk/uzivatel/objednavky/:id",
    component: _0ecd6206,
    name: "user-orders-id___sk"
  }, {
    path: "/sk/clanky/:slug",
    component: _56f3b621,
    name: "articleList-slug___sk"
  }, {
    path: "/sk/clanok/:slug",
    component: _768aeee3,
    name: "article-slug___sk"
  }, {
    path: "/sk/konfigurator/:slug",
    component: _7392fb6e,
    name: "configurator-slug___sk"
  }, {
    path: "/sk/pobocky/:slug",
    component: _2376d61b,
    name: "branch-slug___sk"
  }, {
    path: "/sk/produkt/:slug",
    component: _3f3f0b9c,
    name: "product-slug___sk"
  }, {
    path: "/sk/stranka/:slug",
    component: _2bc7a048,
    name: "page-slug___sk"
  }, {
    path: "/uzivatel/nakupni-seznamy/:id",
    component: _e115f69c,
    name: "user-shoppingLists-id___cs"
  }, {
    path: "/uzivatel/objednavky/:id",
    component: _0ecd6206,
    name: "user-orders-id___cs"
  }, {
    path: "/clanek/:slug",
    component: _768aeee3,
    name: "article-slug___cs"
  }, {
    path: "/clanky/:slug",
    component: _56f3b621,
    name: "articleList-slug___cs"
  }, {
    path: "/konfigurator/:slug",
    component: _7392fb6e,
    name: "configurator-slug___cs"
  }, {
    path: "/pobocky/:slug",
    component: _2376d61b,
    name: "branch-slug___cs"
  }, {
    path: "/produkt/:slug",
    component: _3f3f0b9c,
    name: "product-slug___cs"
  }, {
    path: "/stranka/:slug",
    component: _2bc7a048,
    name: "page-slug___cs"
  }, {
    path: "/sk/*",
    component: _2a80cbde,
    name: "all___sk"
  }, {
    path: "/*",
    component: _2a80cbde,
    name: "all___cs"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
